import { store } from "../store/index";
import {
  filterProvider,
  removeProvider,
  modifyProvider,
  getProviderByUuid,
  createProvider,
  getAll,
} from "../store/actions/ProviderActions.js";

/**
 * Create Provider
 */
export const addProvider = async (values) => {
  const objSend = { ...values };
  const result = await store.dispatch(createProvider(objSend));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * Get Provider
 */
export const getProvider = async (uuid) => {
  const param = [uuid];
  const result = await store.dispatch(getProviderByUuid(param));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Update Provider
 */
export const updateProvider = async (values, uuid) => {
  const objSend = { ...values };
  const result = await store.dispatch(modifyProvider(objSend, [uuid]));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * List Provider
 */
export const listFilter = async (filter) => {
  const result = await store.dispatch(filterProvider(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Delete Provider
 */
export const deleteProvider = async (uuid) => {
  const result = await store.dispatch(removeProvider([uuid]));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Get all Providers
 */
export const getAllProviders = async (filters = {}) => {
  const result = await store.dispatch(getAll(filters));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};
